import React from 'react'

/** Keyframes shared by the "try it" cues on the app and community previews. */
export function PreviewHintStyles() {
  return (
    <style>{`
      @keyframes sbx-tap { 0%, 100% { transform: translateY(10px) scale(1); } 38% { transform: translateY(0) scale(1); } 48% { transform: translateY(0) scale(0.86); } 60% { transform: translateY(0) scale(1); } }
      @keyframes sbx-ripple { 0%, 44% { transform: scale(0.3); opacity: 0; } 50% { opacity: 0.85; } 100% { transform: scale(1.7); opacity: 0; } }
      @keyframes sbx-bob { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
      @keyframes sbx-scroll { 0% { transform: translateY(-3px); opacity: 0; } 30% { opacity: 1; } 100% { transform: translateY(5px); opacity: 0; } }
      @keyframes sbx-glow { 0%, 100% { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0); } 50% { box-shadow: 0 0 0 6px rgba(20, 184, 166, 0.28); } }
      @media (prefers-reduced-motion: reduce) {
        .sbx-anim { animation: none !important; }
      }
    `}</style>
  )
}

/** Small white pill that says what to do. Sizes are in the parent's units. */
export function HintBubble({ children, style, fontSize = 13 }) {
  return (
    <span
      className="sbx-anim"
      style={{
        position: 'absolute',
        display: 'inline-flex',
        alignItems: 'center',
        gap: fontSize * 0.45,
        padding: `${fontSize * 0.5}px ${fontSize * 0.95}px`,
        borderRadius: 999,
        background: '#fff',
        color: '#0C0A09',
        fontSize,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        boxShadow: '0 8px 22px rgba(0,0,0,0.28), 0 0 0 0.5px rgba(0,0,0,0.08)',
        animation: 'sbx-bob 2.4s ease-in-out infinite',
        pointerEvents: 'none',
        ...style,
      }}
    >
      {children}
    </span>
  )
}
